export default {
  // Navbar
  "nav": {
    "home": "Inicio",
    "services": "Servicios",
    "environments": "Ambientes",
    "serviceAreas": "Áreas de Servicio",
    "projects": "Áreas de Servicio",
    "about": "Nosotros",
    "contact": "Contacto",
    "getQuote": "Solicitar Cotización",
    "language": "Idioma"
  },
  
  // Hero
  "hero.badge": "Servicios Profesionales de Limpieza Comercial en Los Ángeles",
  "hero.title1": "Excelencia en",
  "hero.title2": "Limpieza Comercial",
  "hero.description": "Soluciones completas de limpieza comercial para empresas en todo el sur de California. Mantenemos sus espacios impecables, organizados y listos para el éxito todos los días.",
  "hero.cta1": "Solicitar Cotización Gratis",
  "hero.cta2": "Nuestros Servicios",
  "hero.stat1": "Premium",
  "hero.stat1Label": "Materiales de Calidad",
  "hero.stat2": "Certificado",
  "hero.stat2Label": "Equipo Calificado",
  "hero.stat3": "100%",
  "hero.stat3Label": "Compromiso",
  "hero.card1Title": "Limpieza de Rutina y Mantenimiento",
  "hero.card1Desc": "Servicios de limpieza diaria, semanal o mensual para mantener su espacio comercial siempre organizado y funcional.",
  "hero.card2Title": "Limpieza General de Ambientes",
  "hero.card2Desc": "Limpieza completa de oficinas, áreas comunes, baños y cocinas con atención a cada detalle.",
  "hero.card3Title": "Limpieza Profunda y Pesada",
  "hero.card3Desc": "Limpieza detallada de pisos, paredes, rodapés, puertas y áreas de difícil acceso para resultados impecables.",
  "hero.card4Title": "Limpieza Post-Construcción",
  "hero.card4Desc": "Remoción completa de escombros, polvo fino y residuos después de proyectos de construcción o renovación.",
  
  // Services
  "services.badge": "Nuestros Servicios",
  "services.title": "Soluciones Profesionales de Limpieza",
  "services.subtitle": "Desde mantenimiento diario hasta limpieza profunda, entregamos resultados impecables que superan las expectativas cada vez.",
  "services.service1Title": "Limpieza de Rutina y Mantenimiento",
  "services.service1Desc": "Limpieza diaria, periódica (semanal, quincenal, mensual) y mantenimiento continuo para mantener su espacio siempre organizado y funcional.",
  "services.service1Feature1": "Servicios de limpieza diaria",
  "services.service1Feature2": "Horarios semanales o quincenales",
  "services.service1Feature3": "Planes de mantenimiento mensual",
  "services.service1Feature4": "Organización continua del espacio",
  "services.service2Title": "Limpieza General de Ambientes",
  "services.service2Desc": "Limpieza completa de salas, áreas comunes, espacios administrativos, baños y cocinas/copas.",
  "services.service2Feature1": "Limpieza de oficinas y salas de reunión",
  "services.service2Feature2": "Mantenimiento de áreas comunes",
  "services.service2Feature3": "Sanitización de baños",
  "services.service2Feature4": "Limpieza de cocinas y copas",
  "services.service3Title": "Limpieza de Vidrios y Superficies",
  "services.service3Desc": "Cuidados específicos con vidrios, pisos y todas las superficies para brilho e higiene impecables.",
  "services.service3Feature1": "Limpieza de ventanas y vidrios",
  "services.service3Feature2": "Pulido y mantenimiento de pisos",
  "services.service3Feature3": "Desinfección de superficies",
  "services.service3Feature4": "Limpieza de espejos y accesorios",
  "services.service4Title": "Limpieza Profunda y Pesada",
  "services.service4Desc": "Servicios detallados de limpieza de pisos, paredes, rodapés, puertas y áreas de difícil acceso.",
  "services.service4Feature1": "Fregado profundo de pisos",
  "services.service4Feature2": "Limpieza de paredes y rodapés",
  "services.service4Feature3": "Detallado de puertas y marcos",
  "services.service4Feature4": "Limpieza de áreas de difícil acceso",
  "services.service5Title": "Limpieza Post-Obra y Reformas",
  "services.service5Desc": "Remoción de residuos, polvo fino, vidrios y superficies después de construcción o reforma, dejando el espacio listo para uso.",
  "services.service5Feature1": "Remoción de escombros de construcción",
  "services.service5Feature2": "Eliminación de polvo fino",
  "services.service5Feature3": "Limpieza de vidrios post-reforma",
  "services.service5Feature4": "Preparación del espacio para uso",
  "services.service6Title": "Coleta y Descarte de Basura",
  "services.service6Desc": "Gestión completa de residuos, coleta y descarte adecuado conforme necesidad del ambiente.",
  "services.service6Feature1": "Coleta diaria de residuos",
  "services.service6Feature2": "Gestión de reciclaje",
  "services.service6Feature3": "Procedimientos de descarte adecuado",
  "services.service6Feature4": "Planificación de gestión de residuos",
  "services.service7Title": "Reposición de Materiales",
  "services.service7Desc": "Reposición básica de materiales inclusos en el contrato, garantizando practicidad y confort en el día a día.",
  "services.service7Feature1": "Reposición de suministros de baño",
  "services.service7Feature2": "Reposición de productos de limpieza",
  "services.service7Feature3": "Recarga de toallas de papel y jabón",
  "services.service7Feature4": "Materiales incluidos en contrato",
  "services.service8Title": "Limpieza Detallada de Áreas Especiales",
  "services.service8Desc": "Servicios específicos para áreas sensibles o con exigencia de cuidado extra.",
  "services.service8Feature1": "Protocolos para áreas sensibles",
  "services.service8Feature2": "Métodos de limpieza especializados",
  "services.service8Feature3": "Sanitización de alto estándar",
  "services.service8Feature4": "Soluciones de limpieza personalizadas",
  "services.service9Title": "Preparación de Espacios",
  "services.service9Desc": "Organización e higienización para uso inmediato, eventos o apertura de nuevos ambientes.",
  "services.service9Feature1": "Preparación de espacios para eventos",
  "services.service9Feature2": "Limpieza de configuración de nuevo espacio",
  "services.service9Feature3": "Sanitización pre-apertura",
  "services.service9Feature4": "Organización para uso inmediato",
  "services.benefit1Title": "Horarios Flexibles",
  "services.benefit1Desc": "Ejecución según cronograma definido con flexibilidad de horarios",
  "services.benefit2Title": "Contratos Estructurados",
  "services.benefit2Desc": "Acuerdos claros con términos y condiciones definidos",
  "services.benefit3Title": "Procesos Estandarizados",
  "services.benefit3Desc": "Procedimientos estandarizados y gestión eficiente",
  "services.benefit4Title": "Calidad Garantizada",
  "services.benefit4Desc": "Satisfacción garantizada en cada proyecto",
  "services.cta": "Comience Hoy",
  
  // Service Areas (replacing Portfolio)
  "serviceAreas.badge": "Cobertura de Servicio",
  "serviceAreas.title": "Áreas que Atendemos",
  "serviceAreas.subtitle": "Servicios profesionales de limpieza comercial en todo el sur de California",
  "serviceAreas.loc_socal_name": "Otras áreas del sur de California",
  "serviceAreas.loc_topanga_name": "Topanga",
  "serviceAreas.loc_pasadena_name": "Pasadena",
  "serviceAreas.loc_santaana_name": "Santa Ana",
  "serviceAreas.loc_riverside_name": "Riverside",
  "serviceAreas.loc_torrance_name": "Torrance",
  "serviceAreas.available": "Área Cubierta",
  "serviceAreas.ctaTag": "Amplíe su Cobertura",
  "serviceAreas.ctaTitle": "¿Necesita Servicio en Otra Área?",
  "serviceAreas.ctaSubtitle": "Contáctenos para discutir opciones de cobertura para su ubicación",
  "serviceAreas.ctaButton": "Contáctenos",
  "serviceAreas.stat1": "Clientes Atendidos",
  "serviceAreas.stat2": "Condados Cubiertos",
  "serviceAreas.stat3": "Disponibilidad",
  
  // About
  "about.badge": "Sobre Nosotros",
  "about.title": "Quiénes Somos - BRAX Facility Group",
  "about.description1": "Nacimos como una empresa familiar, impulsados por el deseo de ofrecer un servicio hecho con cuidado, responsabilidad y dedicación. Aquí, cada detalle importa porque creemos que la confianza se construye día a día.",
  "about.description2": "Ponemos amor en todo lo que hacemos, valoramos las relaciones genuinas y trabajamos con dedicación para superar expectativas. Para nosotros, cada cliente es único, y cada proyecto es una oportunidad de mostrar quiénes somos. Hemos crecido sin renunciar a nuestros valores fundamentales: respeto, transparencia y compromiso con la calidad.",
  "about.feature1": "Profesionales licenciados y asegurados",
  "about.feature2": "Productos de limpieza ecológicos",
  "about.feature3": "Disponibilidad 24/7 para proyectos urgentes",
  "about.feature4": "Inspecciones detalladas de calidad",
  "about.feature5": "Precios transparentes sin cargos ocultos",
  "about.feature6": "Equipo especializado para todas las superficies",
  "about.stat1": "500+",
  "about.stat1Label": "Proyectos Completados",
  "about.stat2": "50+",
  "about.stat2Label": "Miembros del Equipo",
  "about.stat3": "15+",
  "about.stat3Label": "Años de Excelencia",
  "about.stat4": "100%",
  "about.stat4Label": "Satisfacción del Cliente",
  
  // Testimonials
  "testimonials.badge": "Testimonios",
  "testimonials.title": "Lo Que Dicen Nuestros Clientes",
  "testimonials.subtitle": "No solo tome nuestra palabra. Aquí está lo que nuestros clientes satisfechos tienen que decir sobre nuestros servicios.",
  "testimonials.client1Name": "Sarah Mitchell",
  "testimonials.client1Role": "Gerente de Tienda, Boutique de Moda de Lujo",
  "testimonials.client1Location": "Beverly Hills",
  "testimonials.client1Text": "Brax Facility Services Group transformó nuestra nueva tienda antes de la gran inauguración. Cada superficie estaba impecable, y nuestros clientes quedaron impresionados. ¡Servicio absolutamente profesional!",
  "testimonials.client2Name": "Michael Rodriguez",
  "testimonials.client2Role": "Gerente de Proyecto, Desarrollo Comercial",
  "testimonials.client2Location": "Centro de LA",
  "testimonials.client2Text": "Después de un complejo proyecto de construcción de 18 meses, Brax dejó nuestro edificio impecable en tiempo récord. Su atención al detalle es inigualable en la industria.",
  "testimonials.client3Name": "Emily Chen",
  "testimonials.client3Role": "Propietaria de Restaurante",
  "testimonials.client3Location": "Santa Monica",
  "testimonials.client3Text": "La noche de apertura fue un gran éxito gracias a Brax. La cocina, el área de comedor y el patio estaban todos prístinos. ¡Recomiendo altamente sus servicios de gran inauguración!",
  
  // Contact
  "contact.badge": "Contáctenos",
  "contact.title": "Solicite una Cotización Gratis",
  "contact.subtitle": "¿Listo para transformar su espacio? Contáctenos para una cotización gratuita y sin compromiso. Nuestro equipo responderá en 24 horas.",
  "contact.phone": "Teléfono",
  "contact.email": "Correo",
  "contact.location": "Ubicación",
  "contact.locationValue": "Los Ángeles, CA",
  "contact.hours": "Horario",
  "contact.hoursValue": "Disponible 24/7",
  "contact.formName": "Nombre Completo",
  "contact.formEmail": "Correo Electrónico",
  "contact.formPhone": "Número de Teléfono",
  "contact.formService": "Servicio Necesario",
  "contact.formServicePlaceholder": "Seleccione un servicio",
  "contact.formServiceOption1": "Limpieza Post-Construcción",
  "contact.formServiceOption2": "Preparación de Gran Inauguración",
  "contact.formServiceOption3": "Limpieza Inicial",
  "contact.formServiceOption4": "Limpieza de Detalle Final",
  "contact.formServiceOption5": "Otro",
  "contact.formMessage": "Detalles del Proyecto",
  "contact.formMessagePlaceholder": "Cuéntenos sobre su proyecto: ubicación, tamaño, cronograma...",
  "contact.formSubmit": "Enviar Mensaje",
  "contact.formSubmitting": "Enviando...",
  "contact.formSuccess": "¡Mensaje enviado con éxito! Nos pondremos en contacto pronto.",
  "contact.formDisclaimer": "Al enviar, acepta nuestra política de privacidad. Nunca compartimos su información.",
  "contact.fieldRequired": "Este campo es obligatorio",
  
  // Footer
  "footer.description": "Servicio premier de limpieza comercial de Los Ángeles especializado en post-construcción y preparaciones de grandes inauguraciones.",
  "footer.servicesTitle": "Nuestros Servicios",
  "footer.service1": "Limpieza Post-Construcción",
  "footer.service2": "Preparación de Gran Inauguración",
  "footer.service3": "Limpieza Inicial",
  "footer.service4": "Limpieza de Detalle Final",
  "footer.companyTitle": "Empresa",
  "footer.aboutUs": "Sobre Nosotros",
  "footer.ourServices": "Nuestros Servicios",
  "footer.services": "Servicios",
  "footer.testimonials": "Testimonios",
  "footer.contact": "Contacto",
  "footer.areasTitle": "Áreas de Servicio",
  "footer.area1": "Los Ángeles",
  "footer.area2": "Beverly Hills",
  "footer.area3": "Santa Monica",
  "footer.area4": "Hollywood",
  "footer.area5": "Malibu",
  "footer.area6": "Pasadena",
  "footer.copyright": "© 2024 Brax Facility Services Group. Todos los derechos reservados.",
  "footer.privacy": "Política de Privacidad",
  "footer.terms": "Términos de Servicio",
  
  // Brand
  "brand.name": "Brax",
  "brand.subtitle": "Facility Services Group",
  
  // Environments We Serve
  "environments.badge": "Ambientes que Atendemos",
  "environments.title": "Limpieza Especializada para Cada Espacio",
  "environments.subtitle": "Desde instalaciones educativas hasta centros de salud, ofrecemos soluciones de limpieza personalizadas que satisfacen las necesidades únicas de cada ambiente.",
  "environments.env1Title": "Educación",
  "environments.env1Desc": "Creando ambientes de aprendizaje seguros y limpios para estudiantes y personal con protocolos de limpieza especializados para instalaciones educativas.",
  "environments.env1Feature1": "Escuelas e instituciones educativas",
  "environments.env1Feature2": "Guarderías y preescolares",
  "environments.env1Feature3": "Oficinas administrativas y salas de personal",
  "environments.env1Feature4": "Áreas comunes y pasillos",
  "environments.env2Title": "Salud",
  "environments.env2Desc": "Servicios de limpieza de grado médico que mantienen los más altos estándares de higiene para instalaciones de salud y seguridad del paciente.",
  "environments.env2Feature1": "Clínicas y consultorios médicos",
  "environments.env2Feature2": "Consultorios dentales y especializados",
  "environments.env2Feature3": "Centros médicos e instalaciones",
  "environments.env2Feature4": "Protocolos de sanitización de alto estándar",
  "environments.env3Title": "Comercio y Retail",
  "environments.env3Desc": "Manteniendo espacios comerciales impecables y acogedores para los clientes con soluciones integrales de limpieza para ambientes comerciales.",
  "environments.env3Feature1": "Tiendas y boutiques minoristas",
  "environments.env3Feature2": "Centros comerciales y malls",
  "environments.env3Feature3": "Corredores y pasillos comunes",
  "environments.env3Feature4": "Áreas de exhibición y showrooms",
  "environments.env4Title": "Corporativo y Oficinas",
  "environments.env4Desc": "Servicios de limpieza profesional que mantienen espacios de trabajo productivos y saludables para empresas de todos los tamaños.",
  "environments.env4Feature1": "Oficinas corporativas y sedes",
  "environments.env4Feature2": "Edificios administrativos",
  "environments.env4Feature3": "Salas de conferencias y reuniones",
  "environments.env4Feature4": "Centros de negocios y coworking",
  "environments.env5Title": "Áreas Especiales",
  "environments.env5Desc": "Limpieza especializada para espacios sensibles que requieren cuidado extra, atención al detalle y protocolos personalizados.",
  "environments.env5Feature1": "Áreas sensibles y restringidas",
  "environments.env5Feature2": "Espacios que requieren protocolos especiales",
  "environments.env5Feature3": "Limpieza profesional detallada",
  "environments.env5Feature4": "Soluciones de limpieza personalizadas",
  "environments.ctaTitle": "¿Necesita Limpieza para su Espacio?",
  "environments.ctaSubtitle": "No importa qué tipo de instalación administre, tenemos la experiencia y el conocimiento para mantenerla impecable. Contáctenos hoy para un plan de limpieza personalizado.",
  "environments.ctaButton": "Obtener Cotización Personalizada"
};
